<template>
  <div class="p-box__body">
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                <slot name="header" />
              </h3>
            </header>
            <div class="p-box__body">
              <slot name="body" />
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box'
}
</script>
